import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { formatApiErrorDetail } from "@/lib/api";
import { Lock } from "lucide-react";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="grain flex min-h-screen items-center justify-center bg-navy px-5" data-testid="login-page">
      <div className="w-full max-w-md">
        <div className="mb-10 text-center">
          <div className="font-display text-2xl font-bold tracking-tight text-bone">
            PRASCAK <span className="text-kinetic">4</span> PRESIDENT
          </div>
          <div className="mt-2 text-xs uppercase tracking-[0.3em] text-bone/40">Content Studio</div>
        </div>

        <form
          onSubmit={submit}
          className="rounded-sm border border-hairline/70 bg-ink p-8 shadow-2xl"
        >
          <div className="mb-6 flex items-center gap-3 text-bone">
            <Lock size={18} className="text-kinetic" />
            <h1 className="font-display text-2xl font-bold">Team Login</h1>
          </div>

          {error && (
            <div data-testid="login-error" className="mb-5 rounded-sm border border-kinetic/40 bg-kinetic/10 px-4 py-3 text-sm text-kinetic">
              {error}
            </div>
          )}

          <label className="mb-2 block text-xs uppercase tracking-widest text-bone/50">Email</label>
          <input
            data-testid="login-email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            className="mb-5 w-full rounded-sm border border-hairline bg-navy px-4 py-3 text-bone outline-none transition-colors duration-300 focus:border-kinetic"
            placeholder="you@prascak4president.com"
          />

          <label className="mb-2 block text-xs uppercase tracking-widest text-bone/50">Password</label>
          <input
            data-testid="login-password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            className="mb-7 w-full rounded-sm border border-hairline bg-navy px-4 py-3 text-bone outline-none transition-colors duration-300 focus:border-kinetic"
            placeholder="••••••••"
          />

          <button
            data-testid="login-submit"
            type="submit"
            disabled={loading}
            className="w-full rounded-full bg-kinetic py-3.5 text-sm font-semibold uppercase tracking-wider text-white transition-transform duration-300 hover:-translate-y-0.5 disabled:opacity-60"
          >
            {loading ? "Signing in…" : "Sign In"}
          </button>
        </form>
      </div>
    </div>
  );
}
